import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { assetsConst } from 'src/app/core/const/assets.const';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { manageAreaService } from 'src/app/core/services/manageArea.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToasterService } from 'src/app/core/services/toastr.service';
import { CommonResponse } from 'src/app/models/commomResponse';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'megastore-admin-assign-area',
  templateUrl: './assign-area.component.html',
  styleUrls: ['./assign-area.component.scss']
})
export class AssignAreaComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();
  protected displayedColumns = ['srno', 'name', 'createdat', 'assign'];
  protected assetsConst = assetsConst;
  areaList: Array<any> = [];
  areaFormGroup: FormGroup;
  submitted = false;
  salesManagerId: string | undefined;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { data: string },
    private _spinnerService: SpinnerService,
    private _areaService: manageAreaService,
    private formBuilder: FormBuilder,
    private _toasterService: ToasterService,
    private dialogRef: MatDialogRef<any>,
    private _translateService: TranslateService
  ) {
    this.areaFormGroup = this.formBuilder.group({
      areaId: [[], [Validators.required]]
    });
    if (this.data.data !== undefined) {
      this.salesManagerId = this.data.data;
    }
    this.getAllAreas();
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.areaFormGroup.valid) {
      this.onFormValid();
    }
  }

  onFormValid(): void {
    this._spinnerService.addToLoader('addArea');
    this._areaService
      .assignArea(this.areaFormGroup.value, this.salesManagerId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: CommonResponse) => {
          if (res) {
            this._spinnerService.removeFromLoader('addArea');
            this._toasterService.successToastr(
              this._translateService.instant('Successful')
            );
            this.dialogRef.close(res);
          }
        },
        error: () => {
          this._spinnerService.removeFromLoader('addArea');
        }
      });
  }

  getAllAreas(): void {
    this._spinnerService.addToLoader('getAreaList');
    this._areaService
      .getAreaListing(this.salesManagerId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this._spinnerService.removeFromLoader('getAreaList');
          this.areaList = res.data;
          if (this.areaList && this.areaList.length) {
            this.areaFormGroup
              .get('areaId')
              ?.addValidators(Validators.required);
            this.areaFormGroup.get('areaId')?.updateValueAndValidity();
            const selectedAreas = this.areaList.filter(
              item => item.areaIncluded
            );
            this.areaFormGroup.patchValue({
              areaId: selectedAreas.map(area => area._id)
            });
          } else {
            this.areaFormGroup.get('areaId')?.clearValidators();
            this.areaFormGroup.get('areaId')?.updateValueAndValidity();
          }
        },
        error: () => {
          this._spinnerService.removeFromLoader('getAreaList');
        }
      });
  }
}
